const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#12437d',
                hover: '#0a366a'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
